import React, { useEffect } from "react";
import Button, { ButtonColorTypes } from "../shared-components/Button";
import { useConfirmationDialog } from "../shared-components/ConfirmationDialog";
import { useUpdateArticleRating } from "../api/ItemsApi";
import { ArticleActions, ItemWithMetaData } from "../api/Items";
import LoadingSpinner from "../shared-components/LoadingSpinner";
import { PlusIcon } from "@heroicons/react/24/solid";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { useReportTimer } from "../reports/ReportDetailProvider";

type Props = {
  handleAction: (action: "add" | "cancel" | "completed") => void;
  item: ItemWithMetaData;
};

const ButtonWebContentAddBack = ({ item, handleAction }: Props) => {
  const { hide, modal, show } = useConfirmationDialog();
  const { resetTimer } = useReportTimer();
  const { mutate: updateArticleRating, isSuccess } = useUpdateArticleRating();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  function performAction() {
    setIsLoading(true);
    setTimeout(() => {
      handleAction("add");
    }, 333);
  }

  useEffect(() => {
    if (isSuccess) {
      handleAction("completed");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  function handleAdd() {
    show(
      "",
      "",
      (action) => {},
      <>
        <div>
          <div className="flex gap-4">
            <div>
              <div className="bg-green-100 text-green-600 rounded-full p-2">
                <ExclamationCircleIcon className="w-6" />
              </div>
            </div>
            <div>
              <div className="text-xl">Add Item back?</div>
              <p className="pt-2 text-gray-500">
                By doing this you will be moving the item to the Added section.
              </p>
              <div className="flex gap-4 mt-3 justify-end">
                <Button
                  text={"Cancel"}
                  colorType={ButtonColorTypes.cancel}
                  onClick={() => hide()}
                />
                <Button
                  text="OK"
                  className="w-32"
                  colorType={ButtonColorTypes.primary}
                  onClick={() => {
                    updateArticleRating({
                      item_uuid: item.item.external_id,
                      article_action: ArticleActions.ADDED,
                    });
                    resetTimer?.();
                    performAction();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </>,
      false
    );
  }

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="hover:bg-slate-200 rounded-md">
      <Button
        text={
          <div className="flex gap-2">
            <PlusIcon className="w-4" />
            <span>Add Back</span>
          </div>
        }
        onClick={handleAdd}
      />
      {modal}
    </div>
  );
};

export default ButtonWebContentAddBack;
